(ns frontend.view.grid.contract-kyc-grid.columns
  (:require
   [frontend.state.current-session :as session]))

;;default set of selected columns
(def ordered-default-columns
  [:contract-kyc-profile/name
   :contract-kyc-profile/status
   :contract-kyc-profile/next-deadline
   :contract-kyc-profile/latest-process-status
   :contract-kyc-profile/their-kyc-contact
   :contract-kyc-profile/our-kyc-contact])

(def default-columns
  (set ordered-default-columns))

(defn get-ordered-default-columns
  []
  (vec
   (concat [:contract-kyc-profile/name
            :contract-kyc-profile/status]
           (when (session/screening?)
             [:contract-kyc-profile/screening-enabled?])
           [:contract-kyc-profile/next-deadline
            :contract-kyc-profile/latest-process-status
            :contract-kyc-profile/their-kyc-contact
            :contract-kyc-profile/our-kyc-contact])))

(defn get-default-columns
  []
  (set
   (concat [:contract-kyc-profile/name
            :contract-kyc-profile/status]
           (when (session/screening?)
             [:contract-kyc-profile/screening-enabled?])
           [:contract-kyc-profile/next-deadline
            :contract-kyc-profile/latest-process-status
            :contract-kyc-profile/their-kyc-contact
            :contract-kyc-profile/our-kyc-contact])))

;;always selected:
(def mandatory?
  #{:contract-kyc-profile/name})

